function EmbeddedClassroomNotice() {
  return (
    <div className="flex flex-column items-center justify-center h-screen bg-white p2 center">
      <p className="mb1">This classroom can&apos;t be shown inside another page.</p>
      <p className="text-gray">To join a class, open it in its own browser tab.</p>
    </div>
  );
}

export { EmbeddedClassroomNotice };
